// src/Components/Common/Navbar.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import Logo from '../../assets/images/logo.png';
import '../../Stylesheets/Public/Navbar.css';

const NAV_SECTIONS = ['home', 'modules', 'features', 'pricing', 'faq'];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setIsMenuOpen(false);

  const handleNavClick = (section) => {
    const scrollToSection = () => {
      const el = document.getElementById(section);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        requestAnimationFrame(scrollToSection);
      }, 100);
    } else {
      scrollToSection();
    }

    closeMenu();
  };

  return (
    <header className={`site360-navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner">
        {/* Logo */}
        <div className="logo-section">
          <img src={Logo} alt="Site360 Logo" className="logo" />
          {/* <div className="logo-text">
            <div className="brand-name">Site360</div>
            <div className="tagline">Smarter Site Management</div>
          </div> */}
        </div>

        {/* Desktop Nav */}
        <nav className="nav-links desktop-only">
          {NAV_SECTIONS.map((section) => (
            <span
              key={section}
              className="nav-item"
              onClick={() => handleNavClick(section)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </span>
          ))}
        </nav>

        {/* Auth (desktop) */}
        <div className="auth-buttons desktop-only">
          <RouterLink to="/signin" className="signin no-link-style">
            Sign In
          </RouterLink>
          <RouterLink to="/signup" className="no-link-style">
            <button className="signup-btn">Sign Up</button>
          </RouterLink>
        </div>

        {/* Mobile icon */}
        <div className="mobile-menu-icon" onClick={() => setIsMenuOpen(true)}>
          <FaBars size={22} />
        </div>
      </div>

      {/* Mobile Drawer */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            className="mobile-drawer"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <div className="drawer-header">
              <FaTimes className="close-icon" onClick={closeMenu} />
            </div>

            {NAV_SECTIONS.map((section) => (
              <span
                key={section}
                className="drawer-link"
                onClick={() => handleNavClick(section)}
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </span>
            ))}

            <div className="drawer-auth">
              <RouterLink to="/signin" className="signin no-link-style">
                Sign In
              </RouterLink>
              <RouterLink to="/signup" className="no-link-style">
                <button className="signup-btn">Sign Up</button>
              </RouterLink>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
